import { RIBBON_WITH_COIN_ICON_URL } from 'honeydew/icons/PlusMembership';
import { getResizedCDNAsset } from 'utils/globalUtils';

import BenefitBase from './shared/BenefitBase';

/**
 * ExclusiveDealsBenefit component that displays exclusive weekly deals benefit
 * @param {Object} props - Component props
 * @param {string} [props.bgColor='bg-white'] - Background color class for the benefit
 * @param {'horizontal' | 'responsive'} [props.layout='responsive'] - Layout orientation for the benefit
 * @returns {JSX.Element} Rendered exclusive deals benefit
 */
function ExclusiveDealsBenefit({ bgColor = 'bg-white', layout = 'responsive' }) {
    const horizontalImage = (
        <img
            src={getResizedCDNAsset({ url: RIBBON_WITH_COIN_ICON_URL, width: 300 })}
            alt="ribbon with coin"
            width={150}
        />
    );

    const verticalImage = (
        <img
            src={getResizedCDNAsset({ url: RIBBON_WITH_COIN_ICON_URL, width: 200 })}
            alt="ribbon with coin"
            width={100}
        />
    );

    return (
        <BenefitBase
            bgColor={bgColor}
            headline="Exclusive weekly deals"
            subheadline="Get members-only discounts on 200+ items"
            verticalImage={verticalImage}
            horizontalImage={horizontalImage}
            horizontalImagePosition="bottom-[-20px] left-0 right-[-30px] top-[-20px]"
            layout={layout}
        />
    );
}

export default ExclusiveDealsBenefit;
